<template>
  <div>
      <h1 class="mobiTitle white lg content" id="contentTitle">
        {{getSubCategory($route.params.subcategory, lang_playmix)}} 
      </h1>
      <div class="main_wrap">
        <div class="mobiSection">
          <div class="mobiSection__header">
              <h2 class="mobiTitle md">
                  <span :class="icon"> </span>
                  <span class="text_color">{{ $t("all")}} {{getSubCategory($route.params.subcategory, lang_playmix)}}</span>
              </h2>
          </div>
          <div v-if="isLoad === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div v-if="isLoad === true">
            <div class="mobiSection__content">
              <div class="row">
                <div class="col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem" v-for="dat in data" :key="dat.key">
                  <router-link class="browse_link mobiVideo mobiVideo--mrgn" :to="{
                    name: 'DetailPage',
                    params: { id: dat.content_id }
                    }">
                    <div class="mobiVideo__thumb">
                      <img class="img_wrp" :src="dat.cover_img" alt="" />
                    </div>
                    <div class="playBtn"><span></span></div>
                    <div class="mobiVideo__info">
                      <!-- <h3 class="mobiTitle sm text_color">{{ dat.content_name }}</h3> -->
                      <span v-if="lang_playmix !== 'english'">
                        <h3 class="mobiTitle sm text_color" v-if="dat[`cont_name_${lang_playmix}`] !== ''">{{ dat[`cont_name_${lang_playmix}`] }}</h3>
                        <h3 class="mobiTitle sm text_color" v-else>{{ dat[`cont_name_english`] }}</h3>
                      </span>
                      <span v-else>
                        <h3 class="mobiTitle sm text_color">{{ dat[`cont_name_english`] }}</h3>
                      </span>
                      <div>   
                          <!-- <p>{{ dat.total_download }} Downloads</p> -->
                        <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                        :rating="Number(dat.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- <router-link style="text-decoration:none;" :to="{
            name: 'Category',
            params: { category: category}
            }" class="browse_link">
        {{category}}</router-link> -->

        <!-- <h1 class="main_title">{{subcategory}}</h1> -->
        <!-- <select name="" id="" @change="getSubContent($event)">
            <option value="">--Select View--</option>
            <option value="200">200</option>
            <option value="100">100</option>
            <option value="50">50</option>
            <option value="20">20</option>
            <option value="10">10</option>
            <option value="5">5</option>
        </select> -->
      
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },
  components:{
    StarRating
  },
  props: ["browse"],
  computed: mapGetters(["lang_playmix", "country_playmix", "host_playmix"]),
  created() {
    //replace '_' with blank space\
    let subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    // let e = undefined;
    this.getSubContent(this.$route.params.subcategory);
  },
  updated() {
    if(this.$route.params.subcategory != this.subcategory){
      this.isLoad = false
      this.data = {}
      this.getSubContent(this.$route.params.subcategory)
      
      this.subcategory = this.$route.params.subcategory;
    }
  },
  methods: {
    getSubContent(subcategory) {
      let limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      let live = `http://cook.grabmobi.com/`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;
      axios
        .get(
          `${live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${subcategory}&limit=100&offset=0&domain=${this.host_playmix}&lang=${this.lang_playmix}`
        )
        .then(res => {
          let data = res.data.data;

          this.data = data;
          this.isLoad = true
        })
        .catch(err => {
          // console.log(err);
        });
    },
    getSubCategory(subcategory, lang) {
      let cat_translate = [];
      let hotpick = this.$props.browse.category;
      hotpick.map(item => {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item[`title_${lang}`]);
          } else {
            cat_translate.push(item[`title_english`]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
  text-transform: uppercase;
}

.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}

img.icons {
  background: black;
  height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/playmix/Subcategory.vue